import * as React from 'react';
import { discreteDarkColor } from '../common/Style';
import { generateId, Id } from '../common/Id';
import { Messages } from '../../gen-src/Localize';

const userStyle: React.CSSProperties = {
  color: discreteDarkColor
};

/**
 * Test id attribute value (prefix) for certifier component.
 */
export const certifierTestId: Id = 'certifier';
export const certifierLinkTestId: Id = 'certifier-link';

/**
 * Props for certifier component.
 */
export interface CertifierProps {
  displayName: string;
  url?: string;
  newTab?: boolean;
  id?: Id;
  linksDisabled?: boolean;
  customUserStyle?: React.CSSProperties;
}

/**
 * Certifier component.
 * @param props - The props for this certifier. Note that props are intersected with HTML props so that the styling can changed for
 * different use cases.
 */
export function CertifierComponent(props: CertifierProps & React.HTMLProps<HTMLSpanElement>): React.ReactElement<CertifierProps> {
  let user: JSX.Element;
  if (!props.linksDisabled && props.url) {
    user = (
      <a
        data-tb-test-id={generateId(certifierLinkTestId, props.id)}
        style={userStyle}
        href={props.url}
        target={props.newTab ? '_blank' : undefined}
      >
        {props.displayName}
      </a>
    );
  } else {
    user = <span style={(props.customUserStyle) ? props.customUserStyle : undefined}>{props.displayName}</span>;
  }
  return (
    <span data-tb-test-id={generateId(certifierTestId, props.id)} className={props.className} style={props.style}>
      {Messages.CertifiedBy()} {user}
    </span>
  );
}
